// extracted by css-extract-rspack-plugin
export default {"floatChatikActivator":"float-chatik-activator--Vyzeg4nl_LIwFlvB","lLite":"l-lite--EtUzMKYgipgjomZ6","xsFriendly":"xs-friendly--wTA4_R9kzno5gwbj","title":"title--r2FxPbDjHc9v2yA2"};